<template>
  <v-container fluid grid-list-md text-md-center>
    <v-form ref="form">
      <v-card class="search-section">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6>
              <v-select
                no-data-text="لا يوجد بيانات"
                @change="selectCity"
                :value="selectedCity"
                :items="cities"
                item-text="name"
                item-value="id"
                label="المدينة"
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-select
                no-data-text="لا يوجد بيانات"
                @change="selectCategory"
                :value="selectedCategory"
                :items="categories"
                item-text="name"
                item-value="id"
                label="التصنيف"
              ></v-select>
            </v-flex>
            <v-btn color="success" @click="validate">البحث</v-btn>
            <!--   <v-btn :disabled="!valid" color="success" @click="validate">Validate</v-btn>
 
    <v-btn color="error" @click="reset">Reset Form</v-btn>

            <v-btn color="warning" @click="resetValidation">Reset Validation</v-btn>-->
          </v-layout>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({}),
  props: {
    routeName: null
  },
  created() {
    this.getLookups();
  },
  computed: {
    ...mapState({
      cities: state => state.SearchStore.cities,
      categories: state => state.SearchStore.categories,
      selectedCategory: state => state.SearchStore.selectedCategory,
      selectedCity: state => state.SearchStore.selectedCity
    })
  },
  methods: {
    ...mapActions([
      "getLookups",
      "selectCategory",
      "selectCity",
      "getMissings"
    ]),
    validate() {
      this.selectCity(this.selectedCity);
      this.selectCategory(this.selectedCategory);
      this.getMissings();
      if (this.routeName != null) this.$router.push(this.routeName);
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style scoped>
.search-section {
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 1) 66%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 1) 66%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.5) 0%,
    rgba(255, 255, 255, 1) 66%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#80ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
}
</style>

